$(function() {
	//default ajax behaviour
	$.ajaxSetup({
		cache: false,
		error: function(obj2, status2, err) {
			console.log(obj2.responseText);
			console.log(err);
		},
	});

	// MOBILE NAV - TOGGLE CLICK
	$('#nav-label').on('click', function(e) {
		$('html').toggleClass('nav-open');
		e.preventDefault();
	});

	// Close menu on blur click
	$('.blur').on('click', function(e) {
		$('html').toggleClass('nav-open');
		e.preventDefault();
	});

	/* toggle show/hide search */
	$('.search-with-slide').on('click', '.btn', function(e) {
		e.preventDefault();

		var inputParent = $(this).prev('.input-combined');
		var input = inputParent.find('.form-input');

		inputParent.toggleClass('show');

		if (inputParent.hasClass('show')) {
			input.focus();
		} else {
			input.blur();
		}
	});

	$('iframe[src*="youtube.com"]').each(function() {
		if (
			!(
				$(this)
					.parent()
					.hasClass('video-container-banner') ||
				$(this)
					.parent()
					.hasClass('video-container')
			)
		) {
			$(this).wrap('<div class="video-container"></div>');
		}
	});

	$(document).on('mouseup touchend', function(e) {
		var container = $('.filter-description ');
		if (!container.is(e.target) && container.has(e.target).length === 0)
			container.removeClass('show');
	});

	// Some variables
	var isMobile = navigator.userAgent.match(
			/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i
		),
		isTouch =
			isMobile !== null ||
			document.createTouch !== undefined ||
			'ontouchstart' in window ||
			navigator.msMaxTouchPoints;

	var clickEvent = isTouch ? 'touchend' : 'click';

	var touchmoved;
	// MOBILE NAV - TOGGLE CLICK
	$('.toggle-btn')
		.on(clickEvent, function(event) {
			if ((event.type == 'touchend' || event.type == 'click') && touchmoved != true) {
				$(this)
					.parent('li')
					.toggleClass('open');
				$(this)
					.next()
					.slideToggle(200);
			}
		})
		.on('touchmove', function(e) {
			touchmoved = true;
		})
		.on('touchstart', function() {
			touchmoved = false;
		});

	//HOVERINTENT lte9
	$('.lte9 #main-nav').hover(
		function() {
			var nav = $(this);
			setTimeout(function() {
				nav.addClass('hoverIntent');
			}, 200);
		},
		function() {
			$(this).removeClass('hoverIntent');
		}
	);

	// list-click (v2.0)
	$('.list-click').on(
		'click',
		'.list-item, .entrance-item, .entrance-inner, .teaser-inner',
		function(event) {
			if ($(event.target).is(":not('a, input, label, label *, select, button, button *')")) {
				window.location = $(this)
					.find('a')
					.attr('href');
			}
		}
	);

	// EXTERNAL LINKS in new tab/window (v1.0)
	$('a[rel="external"]').click(function(event) {
		window.open($(this).attr('href'));
		event.preventDefault();
	});

	// IMAGE CAPTIONS (v1.0)
	$('img.imgLeft[title],img.imgRight[title],img.imgCenter[title]').each(function() {
		var caption = $(this).attr('title');
		$(this)
			.wrap(
				'<figure class="' +
					$(this).attr('class') +
					'" style="max-width: 100%; width: ' +
					$(this).attr('width') +
					'px;"></figure>'
			)
			.removeAttr('title')
			.removeAttr('class');
		$(this)
			.parent()
			.append('<figcaption>' + caption + '</figcaption>');
	});

	// GENERIC RESIZE SCRIPT (responsive + retina images)
	// $(window).smartresize(function () {
	// 	viewportWidth = viewportSize.getWidth();
	// 	$('img[data-resize="true"]').GenericResize({
	// 		currentBreakpoint: dnz.breakPoint.getCurrent(),
	// 		hideWhenNoSource: false
	// 	});
	// }).trigger('resize');

	if ($('html').is('.touch')) {
		window.addEventListener('orientationchange', function() {}, false);
	}

	FormFields.Init();

	Conditional.Init();

	dnz.breakPoint.init();

	// Activate hoverOnTouch for breakpoint 3 and up
	if (dnz.breakPoint.getCurrent() > 2) {
		$('#main-nav li:has(div.sub)').hoverOnTouch();
	}

	// Activate hoverOnTouch on [hoverontouch]
	$('[hoverontouch].has-sub').hoverOnTouch();

	$('.btn-disabled').on('click', function(e) {
		e.preventDefault();
	});

	$('[data-tooltip]').tooltip({
		items: '[data-tooltip]',
		content: function() {
			return $(this).data('tooltip');
		},
	});
});

// NOSCROLL ON OPEN NAV
function noScroll() {
	if ($('.nav-open').length && dnz.breakPoint.getCurrent() < 3) {
		$('#content, #content > *, .footer, #subHeader, #nav-label')
			.on('touchmove', function(e) {
				e.preventDefault();
			})
			.on('click', function(e) {
				e.preventDefault();
			});
	} else {
		$('#content, #content > *, .footer, #subHeader')
			.unbind('touchmove')
			.unbind('click');
	}
}

//override the 'more' links with custom script, because of the tabs in the seach results page
function setMoreLinks() {
	$('.acResults .products .footer a.showMoreLink')
		.unbind('click')
		.bind('click', function() {
			$('#hidSearchTab').val('producten');
			window.location.href = $('#btnSubmitSearch').attr('href');
		});
	$('.acResults .combinations .footer a.showMoreLink')
		.unbind('click')
		.bind('click', function() {
			$('#hidSearchTab').val('combinaties');
			window.location.href = $('#btnSubmitSearch').attr('href');
		});
	$('.acResults .information .footer a.showMoreLink')
		.unbind('click')
		.bind('click', function() {
			$('#hidSearchTab').val('overigen');
			window.location.href = $('#btnSubmitSearch').attr('href');
		});
}

// CUSTOM SELECT FOR CREATING CUSTOM LISTS
function customSelect() {
	$('html').click(function(event) {
		if ($.cookie) {
			$.cookie('lastScrollPos' + window.location.href.split('#')[0], $(this).scrollTop(), {
				expires: 1,
				path: '/',
			});
		}
		if ($(event.target).is(":not('div.custom-select, div.custom-select *')")) {
			$('div.custom-select')
				.closest('.custom-select-container')
				.removeClass('active');
			$('.basket .description .fields > li').removeClass('active');
		}
	});
	$('.custom-select > span')
		.unbind('click')
		.click(function() {
			if (viewportWidth < 768) {
				$(this)
					.closest('.custom-select-container')
					.toggleClass('active')
					.siblings()
					.removeClass('active');
				scrollToElement(this);
			} else {
				$(this)
					.closest('.custom-select-container')
					.toggleClass('active')
					.siblings()
					.removeClass('active');
				$(this)
					.parents('.basket .description .fields > li')
					.toggleClass('active')
					.siblings()
					.removeClass('active');
			}
		});
}

function scrollToElement(element) {
	var $element = $(element);
	var topPos = $element.offset().top;
	$('html, body').animate({ scrollTop: topPos - 100 });
}
